<template>
  <div>
    <div class="card exchange-history-card" v-if="isDesktop">
      <div class="card-body">
        <div class="wallet-history">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th class="trade-id-column">{{ labels.orderId }}</th>
                  <th class="trade-timestamp-column">{{ timestampLabel }}</th>
                  <th class="trade-center-column trade-type-column">{{ labels.type }}</th>
                  <th class="trade-center-column trade-order-type-column">{{ labels.orderType }}</th>
                  <th class="trade-center-column">{{ labels.code }}</th>
                  <th class="trade-name-column">{{ labels.name }}</th>
                  <th class="trade-number-column">{{ labels.quantity }}</th>
                  <th class="trade-number-column trade-price-column">{{ labels.price }}</th>
                  <th class="trade-number-column trade-total-column">{{ labels.totalAmount }}</th>
                  <th class="trade-action-column"></th>
                </tr>
              </thead>
              <tbody>
                <tr class="center_verticaly" v-for="(transaction, index) in trades" :key="index">
                  <td class="trade-id-column">#{{ transaction.oid }}</td>
                  <td class="trade-timestamp-column">{{ dateResolver(transaction.ts) }}</td>
                  <td class="trade-center-column trade-type-column">{{ capitalizeFirstLetter(purchaseTypeResolver(orderFor(transaction)?.data?.type)) }}</td>
                  <td class="trade-center-column trade-order-type-column">{{ capitalizeFirstLetter(orderTypeResolver(orderFor(transaction)?.data?.action)) }}</td>
                  <td class="trade-center-column">{{ transaction.sc.toUpperCase() }}</td>
                  <td
                    class="trade-name-column"
                    :aria-label="isBulgarian ? (transaction?.nBG ? transaction?.nBG : transaction?.nEN) : transaction?.nEN"
                    @mouseenter="setNameTooltip"
                  >
                    <div v-if="isBulgarian">
                      {{ transaction?.nBG ? transaction?.nBG : transaction?.nEN }}
                    </div>
                    <div v-if="isEnglish">{{ transaction?.nEN }}</div>
                  </td>
                  <td class="trade-number-column">{{ parseNumber(transaction?.qty, 0) }}</td>
                  <td v-if="transaction.stid !== 2" class="trade-number-column trade-price-column">
                    {{ formatPrice(transaction?.sp, transaction?.cc).replace(' ', '&nbsp;') }}
                  </td>
                  <td v-else class="trade-number-column trade-price-column">
                    {{ formatPrice(transaction?.sp, '%').replace(' ', '&nbsp;') }}
                  </td>
                  <td class="trade-number-column trade-total-column">
                    {{ formatPrice(tradeTotalAmountResolver(transaction), transaction?.cc).replace(' ', '&nbsp;') }}
                  </td>
                  <td class="trade-action-column">
                    <div class="trade-action-content">
                    <button
                      type="button"
                      class="btn btn-primary"
                      :class="{ 'xsmall-font-size': !isDesktop }"
                      @click.prevent="$emit('open-trade-details', transaction)"
                    >&rarr;</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-else v-for="(transaction, index) in trades" :key="index">
      <div class="card">
        <div class="card-body xsmall-font-size">
          <div class="container p-0">
            <div class="row justify-content-between">
              <div class="col-6">
                #{{ transaction.oid }}<br />
                {{ dateResolver(transaction.ts) }}<br />
                {{ transaction.sc.toUpperCase() }}@{{ transaction.xc.toUpperCase() }}<br />
                {{ orderStatusResolver(orderFor(transaction)?.data) }}
              </div>
              <div class="col-6 text-end my-auto">
                <button
                  type="button"
                  class="btn btn-primary"
                  :class="{ 'xsmall-font-size': !isDesktop }"
                  @click.prevent="$emit('open-trade-details', transaction)"
                >&rarr;</button>&nbsp;
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['open-trade-details'],
  props: {
    trades: { type: Array, required: true },
    tradeListOrders: { type: Array, required: true },
    windowWidth: { type: Number, required: true },
    userLanguage: { type: String, required: true },
    labels: { type: Object, required: true },
    dateResolver: { type: Function, required: true },
    purchaseTypeResolver: { type: Function, required: true },
    orderTypeResolver: { type: Function, required: true },
    orderStatusResolver: { type: Function, required: true },
    tradeTotalAmountResolver: { type: Function, required: true },
    capitalizeFirstLetter: { type: Function, required: true },
    formatPrice: { type: Function, required: true },
    parseNumber: { type: Function, required: true }
  },
  computed: {
    isDesktop() {
      return 1200 < this.windowWidth;
    },
    isBulgarian() {
      return 0 === 'BG'.localeCompare(this.userLanguage);
    },
    isEnglish() {
      return 0 === 'EN'.localeCompare(this.userLanguage);
    },
    timestampLabel() {
      return this.isBulgarian ? "Дата:час" : this.labels.timestamp;
    }
  },
  methods: {
    setNameTooltip(event) {
      const content = event.currentTarget.querySelector("div");
      const name = content?.textContent.trim();

      if (content && content.scrollWidth > content.clientWidth) {
        event.currentTarget.setAttribute("data-tooltip", name);
      } else {
        event.currentTarget.removeAttribute("data-tooltip");
      }
    },
    orderFor(transaction) {
      return this.tradeListOrders.filter(item => {
        return 0 === transaction?.oid.localeCompare(item.oid);
      })[0];
    }
  }
};
</script>

<style scoped>
.exchange-history-card {
  border: 0;
  box-shadow: none;
}

.exchange-history-card .card-body {
  padding: 0;
}

.wallet-history {
  border-top: 1px solid #f0f3fa;
}

.wallet-history table {
  table-layout: fixed;
  width: 100%;
}

.center_verticaly,
.center_verticaly > td {
  vertical-align: middle;
}

.trade-id-column {
  max-width: 10%;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 10%;
}

.trade-timestamp-column {
  text-align: left;
  width: 16%;
  white-space: nowrap;
}

.trade-center-column {
  text-align: center;
  width: 7%;
  white-space: nowrap;
}

.trade-order-type-column {
  width: 12%;
  white-space: nowrap;
}

.trade-name-column {
  max-width: 15%;
  overflow: hidden;
  position: relative;
  text-align: left;
  width: 15%;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.trade-name-column[data-tooltip] {
  overflow: visible;
}

.trade-name-column[data-tooltip]::after {
  background: #0088aa;
  border-radius: 0.25rem;
  color: #ffffff;
  content: attr(data-tooltip);
  left: 0;
  max-width: none;
  opacity: 0;
  padding: 0.35rem 0.5rem;
  pointer-events: none;
  position: absolute;
  top: calc(100% + 0.25rem);
  transition: opacity 0.15s ease-in-out;
  visibility: hidden;
  width: max-content;
  white-space: nowrap;
  z-index: 10;
}

.trade-name-column[data-tooltip]:hover::after {
  opacity: 1;
  visibility: visible;
}

.trade-name-column > div {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trade-number-column {
  text-align: right;
  vertical-align: middle;
  white-space: nowrap;
  width: 7%;
}

.trade-price-column,
.trade-total-column {
  text-align: right;
}

.trade-price-column {
  width: 9%;
}

.trade-total-column {
  width: 11%;
}

.trade-action-column {
  padding-left: 0;
  padding-right: 0;
  text-align: right;
  width: 3rem;
}

td.trade-action-column {
  vertical-align: middle;
}

.trade-action-content {
  align-items: center;
  display: flex;
  justify-content: flex-end;
}

.xsmall-font-size {
  font-size: x-small;
}
</style>
